<template>
    <b-container fluid class="content-box-white">
        <b-container>
            <b-row v-animate-onscroll="'animated fadeInLeft'" class="content-section">
                <b-col cols="12" class="h-1"> </b-col>
                <b-col cols="12" md="6" class="content-area">
                    <h2 id="sub-header-1" v-html="contentTop.content_title"></h2>
                    <div id="sub-content-1" v-html="contentTop.content_description"></div>
                </b-col>
                <b-col cols="12" md="6" class="content-area">
                    <b-img-lazy v-bind="contentProps" :src="contentTop.content_image"
                        :alt="contentTop.content_title"></b-img-lazy>
                </b-col>
            </b-row>
            <b-row v-animate-onscroll="'animated fadeInRight'" class="content-section">
                <b-col cols="12" md="6" class="content-area">
                    <b-img-lazy v-bind="contentProps" :src="contentBottom.content_image"
                        :alt="contentBottom.content_title"></b-img-lazy>
                </b-col>
                <b-col cols="12" md="6" class="content-area">
                    <h2 id="sub-header-2" v-html="contentBottom.content_title"></h2>
                    <div id="sub-content-2" v-html="contentBottom.content_description"></div>
                </b-col>
            </b-row>
        </b-container>
    </b-container>
</template>

<script>
export default {
    name: 'ContentBoxWhiteTop',
    props: {
        contentTop: { type: Object, required: true, default: null },
        contentBottom: { type: Object, required: true, default: null },
    },
    data() {
        return {
            contentProps: {
                center: true,
                fluidGrow: true,
                blank: true,
                blankColor: "#bbb",
                class: "p-20",
            },
        }
    }
}
</script>

